// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"434":"c59354d2","879":"e96b42a8","898":"974d7fce"}[chunkId] + ".chunk.js";
};